import React from 'react'
import Header from "../components/Header"
import QuizCard from "../components/QuizCard"

export default function App() {
    return (
        <div className="app">
            <div className="main">
                <Header/>
                 <QuizCard/>
            </div>
            
        </div>
    )
}
